import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _mapValues from "lodash/mapValues";
import _isNull from "lodash/isNull";
import _pickBy from "lodash/pickBy";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import platformDefaults from './defaults';

var context = _objectSpread({
  // all top-level `<Type />` is block
  inline: false
}, platformDefaults); // create a context for enabling correct inheritance of props for nested <Type />


export var TypographyContext = /*#__PURE__*/React.createContext(context); // TypographyContextProvider takes the same props as `<Type />`,
// and it merges those props with the existing context value
//
// ex: `<TypographyContextProvider size={3} italic chronicle />`

export var TypographyContextProvider = function TypographyContextProvider(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["children"]);

  var typographyContext = useContext(TypographyContext); // ensure that component props are not null so defaults spread evenly

  var props = _pickBy(otherProps, function (val) {
    return !_isNull(val);
  });

  return /*#__PURE__*/React.createElement(TypographyContext.Provider, {
    // merge new props into context for child <Type /> nodes
    value: _objectSpread(_objectSpread({}, _mapValues(typographyContext, function (val, key) {
      // gotham and chronicle are mutually exclusive. Values in props must override values in context.
      // Without unsetting the other font type, a nested <Type/> will receive both props, which
      // is undefined behavior and has the effect of rendering chronicle. This also must be done in <Type/> Component
      // See https://github.com/NerdWallet/structured-content/pull/298
      // NOTE: `<Type />` refers to `<TypeNative />` in this folder
      if (key === 'gotham' && val && props.chronicle) return false;
      if (key === 'chronicle' && val && props.gotham) return false;
      return val;
    })), props)
  }, children);
};